/**
 * wtshuang@cs.uw.edu
 * 2018/04/23
 * The class for the articles
 */

import { Token } from './Interfaces';
import { utils } from './Utils';


export class Paragraph {
    public aid: number; // article id
    public pid: number; // paragraph id
    public doc: Token[]; // editing type

    constructor (aid: number, pid: number, doc: Token[]) {
        this.aid = aid;
        this.pid = pid;
        this.doc = doc;
    }

    /**
     * Make the instances into raw text
     * @return plain text of the instance.
     */
    public textize(docInput: Token[]|null = null): string {
        let text: string = '';
        const doc = docInput === null ? this.doc : docInput;
        doc.forEach((d: Token) => { text += d.text + d.whitespace; });
        return text;
    }

    /**
     * Make the instances into raw text
     * @return <str[]> plain text of the instances
     */
    public textizeSentences(): string[] {
        const sentenceGroups = utils.groupBy(this.doc, 'sid');
        return Object.keys(sentenceGroups)
            .sort((a, b) => parseInt(a, 10) - parseInt(b))
            .map((s) => this.textize(sentenceGroups[s]));
    }

    
}



// WEBPACK FOOTER //
// ./src/stores/Paragraph.ts